exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.has-text-weight-bold[data-v-35ea6bf8] {\n    background: #fff !important;\n}\n", "", {"version":3,"sources":["/home/vvikas-fedora-hp/dev/hellopeter/portal/src/pages/admin/BusinessBilling.vue"],"names":[],"mappings":";AACA;IACI,4BAA4B;CAC/B","file":"BusinessBilling.vue","sourcesContent":["\n.has-text-weight-bold[data-v-35ea6bf8] {\n    background: #fff !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35ea6bf8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/admin/BusinessBilling.vue
// module id = LL0e
// module chunks = 4